import Loader from "../Tools/Loader";
import { Alert, Button, Stack, Typography } from "@mui/material";
import usePack from "./utils/usePack";
import "../../css/apply.css";
import Aside from "./components/Aside";
import CartButton from "./components/CartButton";
import Course from "./components/Course";
import { Link } from "react-router-dom";

export default function Pack(){

    const { isLoading, isSuccess, isError, data } = usePack();

    return (
        <main className="apply-layout">

            <Aside />

            <section className="apply-section-center">

                {isSuccess && 
                    <Stack spacing={3} sx={{maxWidth: 700, margin: 'auto'}}>

                        <Typography variant="h1">
                            {data?.title}
                        </Typography>

                        {data.courses.map(c =>
                            <Course 
                                course={c}
                                key={c.id}
                            />    
                        )}

                        <Button
                            variant="contained"
                            component={Link}
                            to={`/products/${data.id}/order`}
                        >
                            S'inscrire
                        </Button>

                    </Stack>
                }

                {isLoading &&
                    <Loader />
                }

                {isError &&
                    <Alert severity="error">
                        Le pack est introuvable.
                    </Alert>
                }

            </section>

            <CartButton />

        </main>
    );
}